<template>
  <div class="row">
    <div class="col-md-12" v-if="this.model">
      <h4 class="title">
        <div class="pull-left">Payments for {{ this.model.billing_id }}</div>
        <div class="pull-right">Amount: Rs. {{ this.model.amount }}</div>
      </h4>
    </div>
    <div class="col-md-12 card" v-if="this.model">
      <div class="card-body row">
        
        <div class="col-sm-12 mt-2">
          <el-table
            class="table-striped"
            :data="this.model.payments"
            border
            style="width: 100%;"
            height="600"
          >
            
            <el-table-column
              v-for="(column) in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              :sortable="column.sortable || false"
              :align="column.align"
              :header-align="column.align"
              v-if="!column.hidden"
              :fixed="column.fixed || false"
              :formatter="column.formatter || null"
            ></el-table-column>
            
            <el-table-column :min-width="150" fixed="right" class-name="td-actions" label="Actions" align="center">

              <template slot-scope="props">
                <p-button
                  type="danger"
                  size="sm"
                  icon
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-trash"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- <modal
      :show.sync="modals.add"
      headerClasses="justify-content-center"
      footer-classes="justify-content-center"
      >
      <h5 slot="header" class="modal-title">Payments Manage</h5>
      <form>
        <div class="row">

          <div class="form-group col-12">
            <label for>Note</label>
            <fg-input
              name="note"
              v-model="model.note"
              v-validate="modelValidations.note"
              placeholder="Payment Note"
              :error="getError('note')"
            >
            </fg-input>
          </div>

          <div class="form-group col-6">
            <label for>Employee</label>
            <fg-input
              name="employee_id"
              v-model="model.employee_id"
              v-validate="modelValidations.employee_id"
              :error="getError('employee_id')"
            >
              <el-select
                name="employee_id"
                :class="!getError('employee_id') ? 'select-default' : 'select-danger'"
                class="select-default"
                placeholder="Select Employee"
                v-model="model.employee_id"
                filterable
              >
                <el-option
                  v-for="(option, index) in employees"
                  class="select-success"
                  :value="option.id"
                  :label="`${option.employee_id} - ${option.name}`"
                  :key="index"
                ></el-option>
              </el-select>
            </fg-input>
          </div>

          <div class="form-group col-6">
            <label for>Patient</label>
            <fg-input
              name="patient_id"
              v-model="model.patient_id"
              v-validate="modelValidations.patient_id"
              :error="getError('patient_id')"
            >
              <el-select
                name="patient_id"
                :class="!getError('patient_id') ? 'select-default' : 'select-danger'"
                class="select-default"
                placeholder="Select Patient"
                v-model="model.patient_id"
                filterable
              >
                <el-option
                  v-for="(option, index) in patients"
                  class="select-success"
                  :value="option.id"
                  :label="`${option.patient_id} - ${option.name} -  ${option.phone}`"
                  :key="index"
                ></el-option>
              </el-select>
            </fg-input>
          </div>

          <div class="form-group col-12">
            <label for>Date</label>
            <fg-input
              name="datetime"
              v-model="model.datetime"
              v-validate="modelValidations.datetime"
              :error="getError('datetime')"
            >
              <el-date-picker v-model="model.date" type="date" placeholder="Pick a day" :picker-options="datePickerOptions"></el-date-picker>
            </fg-input>
          </div>

        </div>
      </form>
      <template slot="footer">
        <p-button type="success" @click="validate()">Save Payment</p-button>
      </template>
    </modal> -->

  </div>
</template>


<script>
import Vue from "vue";
import { Modal } from "src/components/UIComponents";
import { Progress, Upload, Table, TableColumn, Select, Option, Slider, DatePicker } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
// import users from "../Tables/users.js";
import swal from 'sweetalert2'
import { mapGetters } from "vuex";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.use(Slider);

export default {
  components: {
    [DatePicker.name]: DatePicker,
    PPagination,
    Modal,
    [Upload.name]: Upload,
    [Progress.name]: Progress,
  },
  mounted() {
    this.$store.dispatch("fetchBilling",this.$route.params.bill_id);
    // this.$store.dispatch("fetchPayments", { per_page: 10, page: 1 });
    // this.$store.dispatch("fetchSimplePatientsAll");
    // this.$store.dispatch("fetchEmployeesAll");
    this.$store.dispatch("fetchModesAll");
  },
  watch: {
      searchQuery: function (val) {
          // this.$store.dispatch("fetchPayments", {
          //     searchQuery: this.searchQuery,
          //     per_page: this.pagination.per_page,
          //     page: this.pagination.current_page
          // }); 
      }
  },
  computed: {
    ...mapGetters({
      tableData: "getPayments",
      model: "getBilling"
    }),
    
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      // if (!this.searchQuery) {
      //   if(this.locations)
      //   this.pagination.total = this.locations.length;
      //   else
      //   this.pagination.total = 0
      //   return this.pagedData;
      // }
      // let result = this.locations.filter(row => {
      //   let isIncluded = false;
      //   for (let key of this.propsToSearch) {
      //     let rowValue = row[key].toString();
      //     if (rowValue.includes && rowValue.includes(this.searchQuery)) {
      //       isIncluded = true;
      //     }
      //   }
      //   return isIncluded;
      // });
      // this.pagination.total = result.length;
      // return result.slice(this.from, this.to);
    }
  },
  data() {
    return {
      scope: 'add',
      modals: {
        add: false,
        edit: false
      },
      datePickerOptions: {
        shortcuts: [{
          text: 'Today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        },
        {
          text: 'Tomorrow',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 1)
            picker.$emit('pick', date)
          }
        },
        {
          text: 'Next week',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50,
          hidden: true,
          align: "center"
        },
        {
          prop: "mode_of_payment.name",
          label: "Mode",
          minWidth: 200,
          fixed: true,
          sortable: true,
          align: "left"
        },
        {
          prop: "transaction_id",
          label: "Txn ID",
          minWidth: 200,
          fixed: true,
          sortable: true,
          align: "left"
        },
        {
          prop: "amount",
          label: "Amount",
          minWidth: 200,
          fixed: true,
          sortable: true,
          align: "right",
          formatter: function(row, column, cellValue, index){
            return  `Rs. ${cellValue}`; 
          }
        },
        {
          prop: "datetime",
          label: "Date",
          minWidth: 200,
          fixed: false,
          sortable: true,
          align: "center",
          formatter: function(row, column, cellValue, index){
            var d = new Date(row.datetime);
            var options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }
            return  d.toLocaleDateString('en-US', options); 
          }
        }
      ],
      modelValidations: {
        
        note: {
          required: false
        },
        employee_id: {
          required: true
        },
        patient_id: {
          required: true
        },
        date: {
          required: true
        },
      }
    };
  },
  methods: {
    handleDelete(index, row) {
      // this.$store.dispatch("deletePayment", row.id);
      swal({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-default btn-fill",
          confirmButtonText: "Delete it!",
          buttonsStyling: false
      })
      .then(result => { 
        this.$store.dispatch("deletePayment", row.id);
        this.$router.push(`/billings/payments/${row.id}`)
       })
      .catch(cancel => { console.log(cancel) });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.modals.add = false;
          switch(this.scope){
            case 'add'  : this.$store.dispatch("createPayment", this.model); break;
            case 'edit' : this.$store.dispatch("updatePayment", this.model); break;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}

button.no-margin{
  margin: 0;
}

.el-table,
.el-table tr,
.el-table thead th {
  background-color: white !important;
}

.form-group .el-input-number {
  width: 35%;
  outline: none;
}
.el-input--small .el-input__inner {
  border-radius: 50px;
}

.picture-container{
  text-align: center;
}
</style>
